import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
    mixins: [reactiveProp],
    extends: Bar,
    data: () => ({
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          labels: {
            render: () => {}
          }
        }
      }
    }),
  mounted() {
    this.renderLineChart()
  },
  methods: {
    renderLineChart() {
      this.renderChart(this.chartData, this.options)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/utils/barChart.js